// Dreamlink Pegasus mark. Per brand canon the Pegasus is ALWAYS shown locked up
// with the DREAMLINK wordmark, never alone — use <DreamlinkLockup/> in chrome,
// not <Pegasus/> by itself. Inherits currentColor.
// Source vector: products/dreamlink/studio/landing/img/pegasus.svg

export function Pegasus({ size = 18, color = 'currentColor' }: { size?: number; color?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 138 138"
      width={size}
      height={size}
      role="img"
      aria-label="Dreamlink"
      style={{ flexShrink: 0, display: 'block', color }}
    >
      <path
        fill="currentColor"
        d="M99.2,20c1.1,4.3,1.3,8.7-1.1,12.6s-1.3,1.7-2,2.6c2-.2,3.9-.8,5.5-2.1s.9-1,1.1-1.1.2.2.2.3c.2,2-.9,4.4-2.1,5.9s-3.3,3.2-5.1,4.7c1.2,0,2.5,0,3.7-.3s1.1-.4,1.6-.5.3,0,.3.1-1.2,1.4-1.4,1.6c-2.2,2.4-4.8,4.6-8,5.7l1.2.2c1.7,0,3.4,0,4.9-.8-1.6,4.2-6.3,6.1-10.5,6.7l1,.3c1.3.2,2.7.4,4,.2.1.1-.9,1-1,1.2-2.7,2.4-6.6,3.1-10.1,2.9l1.1.7c1.2.5,2.4,1,3.8,1,.3.2-2.8,1.2-3,1.3-2.3.6-4.7.8-7.1.6s-1.5-.2-2.2-.3c.5,1.1,1.6,1.7,2.7,2.2-.7.2-1.4.3-2.1.5s.6.4.8.5c2.3,1,3.9,2.5,5.3,4.6,2.4-1.8,5.6-3.2,8.6-2.6,7.2,1.3,10.4,12.8,16.5,13.5,1.9.2,3-.4,4.6-1.1s.2-.2.3,0c-4,5.2-12.7,17.2-19.5,8.9s-3.5-6.9-5.1-10.3-1.7-4.2-3.6-3.6c0,1.1.2,2.2.1,3.3s-.4,2-.3,2.5c0,1.3,2.4,3,3.3,3.8s1.3.7,1.3,1c0,.5-.1,1-.1,1.4,0,1.8,0,3.6,0,5.5l.5,5.9c0,.1-.9.2-1.1.4-.3.4.2,2.5-.3,2.9s-.3,0-.4,0h-4.6c-.4-2,1.4-3.2,2.9-4.1.7-2.8-.2-5.9-1.6-8.3-3.1-.7-5.9-2.3-8.3-4.4,0,.5.2,1,.4,1.5.5,1,1.1,2,1.8,2.9-3.4,2.7-6.8,5.5-10.1,8.3-.3.9.1,2,0,3h-6.1c.1-1.4.6-2.4,1.7-3.3s2-1.1,2.1-1.2.1-.5.2-.7c1-2.3,3-4,4.7-5.7-3.7-2.1-6-6.1-5.3-10.4-3.5.3-7.1,0-10.3-1.5s-5.1-3.9-8.6-4.7-4-.4-6.1-.3l2.2,3.6,1.3,2.7,2.3-.6c1.3,1.1,2.5,2.6,2.7,4.4s.2,2-1.4,2-3-.9-4.1-2.1-1.1-1.5-1.1-1.6-.6,0-.8-.1-1.3-.7-1.5-1-.4-1.2-.6-1.7c-.9-2.2-2.5-4.5-4.1-6.2-.2,1.5-.1,3,.3,4.4s.6,1.9.9,2c.4.1,1.9-.1,2.1,0,.8,2.1.8,4.3.2,6.4-1.7-.6-3.5-1.6-4.3-3.2s-.1-.8-.3-1-.8-.4-1.1-.6c-.5-.3-1.5-1.3-1.6-1.8s0-.6,0-1c0-3.5-1.5-10,3.1-11l5.8-.8c-2.6-7.3,5.3-12.8,4.6-20.1-1,1.4-2.5,2-4.2,2.3s-1.6,0-2.2.2-1.8,1.1-2.4,1.4c-3.7,1.7-5.7.3-5.8-3.7.9-.4,1.6-1.1,2.3-1.8,1.9-1.7,3.6-3.7,5.4-5.5,0-1.3,0-2.6.7-3.8l2.1-3c0,.5.6,1.5,1,1.7s1.5-.4,1.9-.5c9.7-2,15.6,4.7,18.3,13.2.3.9.4,1.9.7,2.7s0,.2.2.1c.5-.1,1.3-1.4,1.6-1.8,1.1-1.6,3.1-6.1,4.3-7s2.8-1.7,4.1-2.6c3.9-2.8,7.3-6.2,9.7-10.3.3,0,2.2,4.9,1.5,5.6,2.3-.2,4.3-1.4,6.1-2.6,4.1-2.9,7.4-7.1,10.3-11h.1Z"
      />
    </svg>
  );
}

// DREAMLINK wordmark + Pegasus lockup (brand canon: always together).
export function DreamlinkLockup({
  markSize = 20,
  color = 'currentColor',
  suffix,
  fontSize = 15,
}: {
  markSize?: number;
  color?: string;
  suffix?: string;
  fontSize?: number;
}) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 10, color }}>
      <Pegasus size={markSize} color={color} />
      <span
        style={{
          fontFamily: "'Cormorant Garamond', Georgia, serif",
          fontWeight: 500,
          fontSize,
          letterSpacing: '0.14em',
          textTransform: 'uppercase',
        }}
      >
        Dreamlink
        {suffix ? (
          <span style={{ fontStyle: 'italic', textTransform: 'none', letterSpacing: '0.02em', opacity: 0.85 }}>
            {' '}
            {suffix}
          </span>
        ) : null}
      </span>
    </span>
  );
}
